import { render } from "./rightBar.vue?vue&type=template&id=60fc11d9&scoped=true"
import script from "./rightBar.vue?vue&type=script&lang=js"
export * from "./rightBar.vue?vue&type=script&lang=js"

import "./rightBar.vue?vue&type=style&index=0&id=60fc11d9&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fc11d9"]])

export default __exports__